/* eslint-disable no-case-declarations */
import i18n from '@/i18n';
import {
    regexEmail,
    regexHalfWidthAlphanumeric,
    regexFullWidthCharacters,
    regexHiragana,
    regexKatakana,
    regexFullWidthKatakana,
    regexHalfWidthKatakana,
    regexDynamicRange
} from '@/utils/regex';
import { getDateFromFullDate, isDateRangeYear } from '@/utils/format';

import { state } from '@/state/modules/manager-form.js';
import { FORMAT_VALUE_PHONE, FORMAT_VALUE_INPUT } from '../handlers';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { OPTION_YES_NO, LIST_MATCHING_CONDITION } from '../components/setting-block-form/constants';
import { checkKeywordPattern } from './handleKeywordbox';

const VALUE_ETC = 'etc';
const VALUE_NAC = 'nac';
const VALUE_NS = 'ns';

const configBlockForm = () => {
    return {
        modelRadio: {},
        modelSelect: {},
        modelCheckbox: {},
        modelProvince: {},
        modelInput: {},
        modelConfirmInput: {},
        modelTextarea: {},
        modelDateForm: {},
        modelInputPhone_1: {},
        modelInputPhone_2: {},
        modelInputPhone_3: {},
        modelFirstName: {},
        modelLastName: {},
        modelPostcode_1: {},
        modelPostcode_2: {},
        modelKeywordBox: {},
        modelUploadFile: {},
        modelRemainingBox: {},

        validateRadio: {},
        validateSelect: {},
        validateCheckbox: {},
        validateProvince: {},
        validateInput: {},
        validateTextarea: {},
        validateDateForm: {},
        validateInputPhone_1: {},
        validateInputPhone_2: {},
        validateInputPhone_3: {},
        validatePhoneCommon: {},
        validateFirstName: {},
        validateLastName: {},
        validateFullnameCommon: {},
        validatePostcode_1: {},
        validatePostcode_2: {},
        validatePostcodeCommon: {},
        validateKeywordBox: {},
        validateUploadFile: {},
        validateRemainingBox: {}
    };
};

const handleFilterBlock = (listBlock, configBlockForm) => {
    for (let list = 0; list < listBlock?.length; list++) {
        let {
            id,
            block_type,
            block_input,
            input_format,
            max_characters,
            order_required,
            input_field_size,
            placeholder,
            setting_others,
            block_phone,
            block_full_name,
            block_post_code,
            block_keyword_box,
            block_date,
            block_checkbox,
            default_choice,
            default_choices,
            value_default_text,
            option_value,
            block_text_area
        } = listBlock[list];
        const conditionConfirmedInput = block_input.confirm_input_twice == OPTION_YES_NO[0]?.id;
        switch (block_type) {
            case ALL_BLOCK_TYPE.BLOCK_RADIO:
                configBlockForm.modelRadio[id] = {
                    radio: default_choice || '',
                    text: value_default_text || ''
                };
                configBlockForm.validateRadio[id] = {
                    configField: {
                        isRequired: false,
                        error: false,
                        messageCustom: true,
                        isInvalid: true,
                        errorField: '',
                        valueSync: default_choice ?? null,
                        typesValidate: onHandleTypeValidateRadio(order_required, setting_others?.value_other_required, default_choice)
                    },
                    configFieldText: {
                        classCustom: '',
                        size: setting_others.width_other,
                        maxlength: max_characters,
                        errorField: '',
                        valueSync: value_default_text ?? '',
                        messageCustom: true,
                        isRequired: false,
                        error: false,
                        typesValidate: []
                    }
                };
                break;
            case ALL_BLOCK_TYPE.BLOCK_SELECT:
                configBlockForm.modelSelect[id] = default_choice || '';
                configBlockForm.validateSelect[id] = {
                    configField: {
                        trackBy: 'unique_key',
                        label: 'value',
                        errorField: '',
                        placeholder: '',
                        valueSync: default_choice ?? null,
                        error: false,
                        isRemove: true,
                        messageCustom: true,
                        isChoiceDefault: true,
                        typesValidate: order_required ? ['requiredSelect'] : []
                    }
                };
                break;
            case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
                configBlockForm.modelCheckbox[id] = {
                    checked: default_choices || [],
                    text: value_default_text || ''
                };
                configBlockForm.validateCheckbox[id] = {
                    configField: {
                        type: 'checkbox',
                        errorField: '',
                        valueSync: default_choices ?? [],
                        messageCustom: true,
                        isInvalid: true,
                        isRequired: false,
                        error: false,
                        typesValidate: onHandleAddTypeValidateCheckBox(
                            order_required,
                            block_checkbox,
                            setting_others?.value_other_required,
                            default_choices
                        )
                    },
                    configFieldText: {
                        classCustom: '',
                        size: setting_others.width_other,
                        maxlength: max_characters,
                        errorField: '',
                        valueSync: value_default_text ?? '',
                        messageCustom: true,
                        isRequired: false,
                        error: false,
                        typesValidate: []
                    }
                };
                break;
            case ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE:
                configBlockForm.modelProvince[id] = default_choice || '';
                configBlockForm.validateProvince[id] = {
                    configField: {
                        trackBy: 'unique_key',
                        label: 'value',
                        errorField: '',
                        placeholder: placeholder || '',
                        valueSync: default_choice ?? null,
                        error: false,
                        isRemove: true,
                        messageCustom: true,
                        isChoiceDefault: true,
                        typesValidate: order_required ? ['requiredSelect'] : []
                    }
                };
                break;
            case ALL_BLOCK_TYPE.BLOCK_INPUT:
                let validateDefault = [];
                let maxLengthHandle = max_characters ? max_characters : 255;
                if (order_required) {
                    validateDefault.push('required');
                }

                switch (input_format?.type_input) {
                    case 'number':
                        validateDefault.push(input_format?.type_input, 'character_range', 'maxlength_textarea');
                        const ageOp =
                            typeof block_input?.age_condition?.operator === 'object'
                                ? block_input?.age_condition?.operator?.value
                                : block_input?.age_condition?.operator;
                        if (ageOp && block_input?.age_condition?.value) {
                            validateDefault.push('age_condition');
                        }
                        break;
                    case 'not_specified':
                    case 'email':
                    case 'half-width_alphanumeric_characters':
                    case 'full-width_characters':
                    case 'hiragana':
                    case 'full-width_katakana':
                    case 'half-width_katakana':
                        validateDefault.push(input_format?.type_input, 'character_range', 'maxlength_textarea');
                        break;
                    case 'numerical_value':
                        maxLengthHandle = Number(max_characters) + 1;
                        validateDefault.push('format_numerical_value', input_format?.type_input, 'range_numerical');
                        break;
                    case 'numeric_value_including_decimal_point':
                        maxLengthHandle = block_input.number_after_decimal_point
                            ? Number(block_input.number_of_digits) -
                              Number(block_input.number_of_decimal_places) +
                              Number(block_input.number_after_decimal_point) +
                              2
                            : Number(block_input.number_of_digits) + 2;
                        validateDefault.push('integerDecimal');
                        break;
                }

                if (block_input.confirm_input_twice == OPTION_YES_NO[0]?.id) {
                    validateDefault.push('keyword_pattern');
                }
                configBlockForm.modelInput[id] = conditionConfirmedInput ? FORMAT_VALUE_INPUT(value_default_text, 0) : value_default_text || '';
                configBlockForm.modelConfirmInput[id] = conditionConfirmedInput
                    ? FORMAT_VALUE_INPUT(value_default_text, 1)
                    : value_default_text || '';
                configBlockForm.validateInput[id] = {
                    configField: {
                        name: input_format?.type_input == 'email' ? 'email' : 'text',
                        autocomplete: block_input.auto_complete === OPTION_YES_NO[0]?.id ? 'on' : 'off',
                        classCustom: '',
                        isNumber: input_format?.type_input == 'number' || false,
                        placeholder: placeholder ? placeholder : '',
                        min: block_input.minimum_number ?? '',
                        max: block_input.maximum_number ?? '',
                        from_range: block_input.from_range ?? '',
                        to_range: block_input.to_range ?? '',
                        integer:
                            block_input?.number_of_digits && block_input?.number_of_decimal_places
                                ? Number(block_input.number_of_digits) - Number(block_input.number_of_decimal_places)
                                : '',
                        decimal: Number(block_input.number_after_decimal_point)
                            ? Number(block_input.number_after_decimal_point)
                            : Number(block_input.number_of_decimal_places) ?? '',
                        maxlength: maxLengthHandle,
                        size: input_field_size ? input_field_size : '',
                        valueSync: conditionConfirmedInput ? FORMAT_VALUE_INPUT(value_default_text, 0) : value_default_text || '',
                        errorField: '',
                        error: false,
                        messageCustom: true,
                        typesValidate: validateDefault
                    }
                };
                break;
            case ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX:
                let validateKeywordDefault = ['keyword_pattern'];
                if (order_required) {
                    validateKeywordDefault.push('required');
                }
                configBlockForm.modelKeywordBox[id] = value_default_text || '';
                configBlockForm.validateKeywordBox[id] = {
                    configField: {
                        autocomplete: 'new-password',
                        type: block_keyword_box?.field_mask_display === OPTION_YES_NO[0]?.id ? 'password' : 'text',
                        classCustom: '',
                        placeholder: placeholder || '',
                        size: input_field_size ? input_field_size : '',
                        valueSync: value_default_text || '',
                        errorField: '',
                        maxlength: max_characters,
                        error: false,
                        messageCustom: true,
                        typesValidate: validateKeywordDefault
                    }
                };
                break;
            case ALL_BLOCK_TYPE.BLOCK_FULL_NAME:
                let validateFullNameDefault = [];
                if (order_required) {
                    validateFullNameDefault.push('required');
                }
                switch (input_format?.type_input) {
                    case 'hiragana':
                    case 'katakana':
                    case 'full-width_katakana':
                    case 'half-width_katakana':
                        validateFullNameDefault.push(input_format?.type_input);
                        break;
                }

                configBlockForm.modelFirstName[id] = FORMAT_VALUE_PHONE(value_default_text, 0);
                configBlockForm.modelLastName[id] = FORMAT_VALUE_PHONE(value_default_text, 1);
                configBlockForm.validateFirstName[id] = {
                    configField: {
                        name: 'lastname',
                        autocomplete: 'family-name',
                        classCustom: 'w-100',
                        size: '10',
                        placeholder: block_full_name.placeholder_first_name || '',
                        maxlength: max_characters,
                        valueSync: FORMAT_VALUE_PHONE(value_default_text, 0) || '',
                        error: false,
                        messageCustom: true,
                        errorField: '',
                        typesValidate: validateFullNameDefault
                    }
                };
                configBlockForm.validateLastName[id] = {
                    configField: {
                        name: 'firstname',
                        autocomplete: 'given-name',
                        classCustom: 'w-100',
                        size: '10',
                        placeholder: block_full_name.placeholder_last_name || '',
                        maxlength: max_characters,
                        valueSync: FORMAT_VALUE_PHONE(value_default_text, 0) || '',
                        error: false,
                        messageCustom: true,
                        errorField: '',
                        typesValidate: validateFullNameDefault
                    }
                };
                configBlockForm.validateFullnameCommon[id] = {
                    configField: {
                        valueSync: `${FORMAT_VALUE_PHONE(value_default_text, 0)} ${FORMAT_VALUE_PHONE(value_default_text, 1)}`,
                        errorField: '',
                        typesValidate: validateFullNameDefault
                    }
                };
                break;
            case ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE:
                configBlockForm.modelPostcode_1[id] = FORMAT_VALUE_PHONE(value_default_text, 0);
                configBlockForm.modelPostcode_2[id] = FORMAT_VALUE_PHONE(value_default_text, 1);
                configBlockForm.validatePostcode_1[id] = {
                    configField: {
                        classCustom: 'w-100',
                        size: '10',
                        placeholder: block_post_code.placeholder_1,
                        valueSync: FORMAT_VALUE_PHONE(value_default_text, 0) || '',
                        errorField: '',
                        maxlength: 3,
                        error: false,
                        messageCustom: true,
                        isAddressNotFound: false,
                        typesValidate: onHandleTypeValidatePostcode(order_required, block_post_code)
                    }
                };
                configBlockForm.validatePostcode_2[id] = {
                    configField: {
                        classCustom: 'w-100',
                        size: '10',
                        placeholder: block_post_code.placeholder_2,
                        valueSync: FORMAT_VALUE_PHONE(value_default_text, 1) || '',
                        errorField: '',
                        maxlength: 4,
                        error: false,
                        messageCustom: true,
                        isAddressNotFound: false,
                        typesValidate: onHandleTypeValidatePostcode(order_required, block_post_code)
                    }
                };
                configBlockForm.validatePostcodeCommon[id] = {
                    configField: {
                        valueSync: `${FORMAT_VALUE_PHONE(value_default_text, 0)}${FORMAT_VALUE_PHONE(value_default_text, 1)}`,
                        errorField: '',
                        isAddressNotFound: false,
                        typesValidate: onHandleTypeValidatePostcode(order_required, block_post_code)
                    }
                };
                break;
            case ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER:
                configBlockForm.modelInputPhone_1[id] = FORMAT_VALUE_PHONE(value_default_text, 0);
                configBlockForm.modelInputPhone_2[id] = FORMAT_VALUE_PHONE(value_default_text, 1);
                configBlockForm.modelInputPhone_3[id] = FORMAT_VALUE_PHONE(value_default_text, 2);
                configBlockForm.validateInputPhone_1[id] = {
                    configField: {
                        classCustom: 'w-100',
                        size: '10',
                        placeholder: block_phone.placeholder_1 || '',
                        valueSync: FORMAT_VALUE_PHONE(value_default_text, 0) || '',
                        errorField: '',
                        maxlength: 5,
                        isNumber: true,
                        error: false,
                        messageCustom: true,
                        typesValidate: onHandleTypeValidateTelephone(order_required)
                    }
                };
                configBlockForm.validateInputPhone_2[id] = {
                    configField: {
                        classCustom: 'w-100',
                        size: '10',
                        placeholder: block_phone.placeholder_2 || '',
                        errorField: '',
                        valueSync: FORMAT_VALUE_PHONE(value_default_text, 1) || '',
                        maxlength: 4,
                        isNumber: true,
                        error: false,
                        messageCustom: true,
                        typesValidate: onHandleTypeValidateTelephone(order_required)
                    }
                };
                configBlockForm.validateInputPhone_3[id] = {
                    configField: {
                        classCustom: 'w-100',
                        size: '10',
                        placeholder: block_phone.placeholder_3 || '',
                        errorField: '',
                        valueSync: FORMAT_VALUE_PHONE(value_default_text, 2) || '',
                        maxlength: 4,
                        isNumber: true,
                        error: false,
                        messageCustom: true,
                        typesValidate: onHandleTypeValidateTelephone(order_required)
                    }
                };
                configBlockForm.validatePhoneCommon[id] = {
                    configField: {
                        errorField: '',
                        valueSync: `${FORMAT_VALUE_PHONE(value_default_text, 0)}${FORMAT_VALUE_PHONE(value_default_text, 1)}${FORMAT_VALUE_PHONE(value_default_text, 2)}`,
                        typesValidate: onHandleTypeValidateTelephone(order_required)
                    }
                };
                break;
            case ALL_BLOCK_TYPE.BLOCK_TEXTAREA:
                configBlockForm.modelTextarea[id] = value_default_text || '';
                configBlockForm.validateTextarea[id] = {
                    configField: {
                        classCustom: !block_text_area.cols ? 'w-100' : '',
                        placeholder: placeholder || '',
                        errorField: '',
                        errorCustomMess: '',
                        valueSync: value_default_text ?? '',
                        length: max_characters || 30000,
                        maxlength: '',
                        error: false,
                        messageCustom: true,
                        typesValidate: order_required ? ['required', 'maxlength_textarea'] : ['maxlength_textarea']
                    }
                };
                break;
            case ALL_BLOCK_TYPE.BLOCK_DATE:
                configBlockForm.modelDateForm[id] = {
                    text: value_default_text || '',
                    select: {
                        year: block_date.select_value_default.year || { unique_key: null, value: '' },
                        month: block_date.select_value_default.month || { unique_key: null, value: '' },
                        day: block_date.select_value_default.day || { unique_key: null, value: '' }
                    }
                };
                configBlockForm.validateDateForm[id] = {
                    configField: {
                        minYear: block_date.format_year.lower_limit,
                        maxYear: block_date.format_year.upper_limit,
                        placeholder_year: block_date.format_year.placeholder,
                        placeholder_month: block_date.format_month_day.placeholder_month,
                        placeholder_day: block_date.format_month_day.placeholder_day,
                        minDateYear: '1800/01/01',
                        maxDateYear: '2100/12/31',
                        errorText: '',
                        errorField: '',
                        valueSync: value_default_text || '',
                        error: false,
                        isSelectDate: false,
                        messageCustom: true,
                        typesValidate: order_required ? ['required', 'date', 'date_year_range'] : ['date', 'date_year_range']
                    },
                    configSelectYear: {
                        trackBy: 'unique_key',
                        label: 'label',
                        isRemove: true,
                        valueSync: block_date.select_value_default.year || { unique_key: null, value: '' },
                        errorField: '',
                        error: false
                    },
                    configSelectMonth: {
                        trackBy: 'unique_key',
                        label: 'label',
                        isRemove: true,
                        valueSync: block_date.select_value_default.month || { unique_key: null, value: '' },
                        errorField: '',
                        error: false
                    },
                    configSelectDay: {
                        trackBy: 'unique_key',
                        label: 'label',
                        isRemove: true,
                        valueSync: block_date.select_value_default.day || { unique_key: null, value: '' },
                        errorField: '',
                        error: false
                    }
                };
                break;
            case ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE:
                configBlockForm.modelUploadFile[id] = default_choice ?? null;
                configBlockForm.validateUploadFile[id] = {
                    configField: {
                        errorField: '',
                        valueSync: default_choice ?? null,
                        error: false,
                        typesValidate: order_required ? ['required'] : []
                    }
                };
                break;
            case ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY:
                configBlockForm.modelRemainingBox[id] = default_choice;
                configBlockForm.validateRemainingBox[id] = {
                    configField: {
                        isRequired: false,
                        error: false,
                        messageCustom: true,
                        isInvalid: true,
                        errorField: '',
                        numberRemainingBox: option_value?.length > 0 ? option_value.reduce((total, item) => total + Number(item.remaining), 0) : null,
                        valueSync: default_choice ?? null,
                        typesValidate: order_required ? ['required', 'no_seat_available'] : []
                    }
                };
                break;
        }
    }
    return configBlockForm;
};

const onHandleTypeValidateRadio = (orderRequired, requiredOther, defaultChoice) => {
    let arrayType = [];
    if (orderRequired) {
        arrayType.push('required');
    }
    if (requiredOther && defaultChoice === VALUE_ETC) {
        arrayType.push('required_other');
    }
    return arrayType;
};

const onHandleTypeValidatePostcode = (orderRequired, postcodeBlock) => {
    let arrayType = ['number'];
    if (orderRequired) {
        arrayType.push('required');
    }
    if (postcodeBlock.feature_search_address === OPTION_YES_NO[0].id) {
        arrayType.shift();
        arrayType.push('zipcode_required', 'number', 'address_not_found');
    }
    return arrayType;
};

const onHandleAddTypeValidateCheckBox = (orderRequired, checkboxBlock, requiredOther, defaultChoices) => {
    let arrayType = [];
    if (orderRequired) {
        arrayType.push('requiredSelect');
    }
    if (['≧', '='].includes(checkboxBlock.operator_limit_check?.value) && checkboxBlock.number_limit_check.toString()) {
        arrayType.push('checked_quantity_error');
    }
    if (requiredOther && defaultChoices.includes(VALUE_ETC)) {
        arrayType.push('required_other');
    }
    return arrayType;
};

const onHandleTypeValidateTelephone = (orderRequired) => {
    let arrayType = ['number', 'character_input'];
    if (orderRequired) {
        arrayType.push('required');
    }
    return arrayType;
};

const handleMatchingAction = (parlistBlockCreated, parblockItem) => {
    const msgState = state().listMessageBlocks;
    const matchingMessages = (errorBlocks) => {
        errorBlocks.forEach((itemError) => {
            if (itemError?.action?.length > 0) return;
            const objMsg = msgState.find((upItem) => upItem.label_id === itemError.label_id);
            if (!objMsg?.label_id) return;
            itemError.action = objMsg.action;
        });
    };
    if (parblockItem?.id) {
        matchingMessages(parblockItem.additional_setting.error_message_block);
        return;
    }
    if (Array.isArray(parlistBlockCreated) && parlistBlockCreated.length > 0) {
        parlistBlockCreated.forEach(({ additional_setting }) => {
            matchingMessages(additional_setting.error_message_block);
        });
    }
};

const matchingMessageBlocks = (configBlockForm, listBlockCreated, blockItem = null) => {
    let checkMessage = true;
    const blockMapping = {
        [ALL_BLOCK_TYPE.BLOCK_RADIO]: 'validateRadio',
        [ALL_BLOCK_TYPE.BLOCK_SELECT]: 'validateSelect',
        [ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE]: 'validateProvince',
        [ALL_BLOCK_TYPE.BLOCK_INPUT]: 'validateInput',
        [ALL_BLOCK_TYPE.BLOCK_CHECKBOX]: 'validateCheckbox',
        [ALL_BLOCK_TYPE.BLOCK_TEXTAREA]: 'validateTextarea',
        [ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE]: 'validateUploadFile',
        [ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY]: 'validateRemainingBox',
        [ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER]: ['validateInputPhone_1', 'validateInputPhone_2', 'validateInputPhone_3', 'validatePhoneCommon'],
        [ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE]: ['validatePostcode_1', 'validatePostcode_2', 'validatePostcodeCommon'],
        [ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX]: 'validateKeywordBox',
        [ALL_BLOCK_TYPE.BLOCK_DATE]: 'validateDateForm',
        [ALL_BLOCK_TYPE.BLOCK_FULL_NAME]: ['validateFirstName', 'validateLastName', 'validateFullnameCommon']
    };
    handleMatchingAction(listBlockCreated, blockItem);
    // start check message blockItem
    if (blockItem?.id) {
        const validateKey = blockMapping[blockItem.block_type];
        if (!validateKey) {
            console.warn(`Unsupported block type: ${blockItem.block_type}`);
            return;
        }
        const filterMsg = blockItem.additional_setting.error_message_block;
        if (Array.isArray(validateKey)) {
            validateKey.forEach((key) => {
                const getConditionField = configBlockForm[key]?.[blockItem.id]?.configField;
                const getConfigField = configBlockForm[key][blockItem.id].configField;
                const getValidationsField = configBlockForm[key][blockItem.id].configField.typesValidate;
                checkMessage = onHandleFilterMessages(
                    filterMsg,
                    getConditionField,
                    getConfigField,
                    getValidationsField,
                    blockItem,
                    key,
                    configBlockForm,
                    checkMessage
                );
            });
        } else {
            const getConditionField = configBlockForm[validateKey]?.[blockItem.id]?.configField;
            const getConfigField = configBlockForm[validateKey][blockItem.id].configField;
            const getValidationsField = configBlockForm[validateKey][blockItem.id].configField.typesValidate;
            checkMessage = onHandleFilterMessages(
                filterMsg,
                getConditionField,
                getConfigField,
                getValidationsField,
                blockItem,
                validateKey,
                configBlockForm,
                checkMessage
            );
        }

        return checkMessage;
    }
    // end check message blockItem

    // start check message all block
    if (!listBlockCreated || listBlockCreated.length <= 0) return checkMessage;
    listBlockCreated.forEach((blockCreateItem) => {
        const { block_type, id, additional_setting } = blockCreateItem;
        const validateKey = blockMapping[block_type];
        if (!validateKey) {
            console.warn(`Unsupported block type: ${block_type}`);
            return;
        }
        if (Array.isArray(validateKey)) {
            validateKey.forEach((key) => {
                const getConditionField = configBlockForm[key]?.[id]?.configField;
                const getConfigField = configBlockForm[key][id].configField;
                const getValidationsField = configBlockForm[key][id].configField.typesValidate;
                checkMessage = onHandleFilterMessages(
                    additional_setting.error_message_block,
                    getConditionField,
                    getConfigField,
                    getValidationsField,
                    blockCreateItem,
                    key,
                    configBlockForm,
                    checkMessage
                );
            });
        } else {
            const getConditionField = configBlockForm[validateKey]?.[id]?.configField;
            const getConfigField = configBlockForm[validateKey][id].configField;
            const getValidationsField = configBlockForm[validateKey][id].configField.typesValidate;
            checkMessage = onHandleFilterMessages(
                additional_setting.error_message_block,
                getConditionField,
                getConfigField,
                getValidationsField,
                blockCreateItem,
                validateKey,
                configBlockForm,
                checkMessage
            );
        }
    });
    return checkMessage;
    // end check message all block
};

const onHandleFilterMessages = (
    pfilterMsg,
    pGetConditionField,
    pGetConfigField,
    pGetValidationsField,
    pBlockItem,
    pValidateKey,
    pconfigBlockForm,
    pCheckMessage
) => {
    let { configSelectYear, configSelectMonth, configSelectDay } = pconfigBlockForm[pValidateKey]?.[pBlockItem.id] ?? {};
    let keyValidate = '';
    for (const validateType of pGetValidationsField) {
        // Lấy value để dùng nhiều lần
        const value = pGetConditionField?.valueSync;
        switch (validateType) {
            case 'requiredSelect':
                keyValidate = 'required';
                break;
            case 'range_numerical':
                keyValidate = 'numerical_value';
                break;
            case 'integerDecimal':
                keyValidate = 'numeric_value_including_decimal_point';
                break;
            default:
                keyValidate = validateType;
        }
        const msgItem = pfilterMsg.find((msg) => msg.type_msg === keyValidate);
        // const msgItemSeat = pfilterMsg.find((msg) => msg.type_msg === 'no_seat_available');
        if (!msgItem) {
            console.warn(`⚠️ Không tìm thấy msgItem cho validateType: ${validateType}, keyValidate: ${keyValidate}`);
            continue;
        }
        switch (keyValidate) {
            case 'required':
                if (pBlockItem.block_type === ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE) {
                    if (pconfigBlockForm.validatePostcode_2[pBlockItem.id].configField?.valueSync) {
                        pGetConfigField.error = false;
                        pGetConfigField.errorField = '';
                    } else {
                        pGetConfigField.error = true;
                        pconfigBlockForm.validatePostcode_1[pBlockItem.id].configField.error = true;
                        pconfigBlockForm.validatePostcode_2[pBlockItem.id].configField.error = true;
                        pGetConfigField.errorField = msgItem.messages;
                        pCheckMessage = false;
                        return false;
                    }
                }

                // if (pBlockItem.block_type === ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY) {
                //     if (pGetConditionField.numberRemainingBox <= 0) {
                //         pGetConfigField.error = true;
                //         pGetConfigField.errorField = tranferMessagesFormShortCode(msgItemSeat?.messages ?? '', { 0: pBlockItem.block_name });
                //         pCheckMessage = false;
                //         return false;
                //     } else {
                //         if (!value) {
                //             pGetConfigField.error = true;
                //             pGetConfigField.errorField = msgItem.messages;
                //             pCheckMessage = false;
                //             return false;
                //         }
                //     }
                // }

                if (!value || value.length === 0) {
                    if (pBlockItem.block_type === ALL_BLOCK_TYPE.BLOCK_DATE) {
                        typeSelectDateValueError(configSelectYear, configSelectMonth, configSelectDay, true);
                    }

                    if (pBlockItem.block_type === ALL_BLOCK_TYPE.BLOCK_FULL_NAME) {
                        pconfigBlockForm.validateFullnameCommon[pBlockItem.id].configField.errorField = msgItem.messages;
                    }

                    pGetConfigField.errorField = msgItem.messages;
                    pCheckMessage = false;
                    return false;
                } else {
                    if (pBlockItem.block_type === ALL_BLOCK_TYPE.BLOCK_DATE) {
                        typeSelectDateValueError(configSelectYear, configSelectMonth, configSelectDay, false);
                    }
                }
                break;
            case 'zipcode_required':
                const configFieldPostCode1 = pconfigBlockForm.validatePostcode_1[pBlockItem.id].configField;
                const configFieldPostCode2 = pconfigBlockForm.validatePostcode_2[pBlockItem.id].configField;
                if (pGetConditionField && !configFieldPostCode1?.valueSync && configFieldPostCode2?.valueSync) {
                    configFieldPostCode1.error = true;
                    pGetConfigField.error = true;
                    pGetConfigField.errorField = msgItem?.messages || null;
                    pCheckMessage = false;
                    return false;
                } else {
                    pGetConfigField.error = false;
                }
                break;
            case 'address_not_found':
                if (pGetConditionField && value && pGetConditionField.isAddressNotFound) {
                    pconfigBlockForm.validatePostcode_1[pBlockItem.id].configField.isAddressNotFoundError = true;
                    pconfigBlockForm.validatePostcode_2[pBlockItem.id].configField.isAddressNotFoundError = true;
                    pGetConfigField.error = true;
                    pGetConfigField.isAddressNotFoundError = true;
                    pGetConfigField.errorField = msgItem?.messages || null;
                }
                break;
            case 'no_seat_available':
                if (pGetConditionField && value && pGetConditionField.numberRemainingBox) {
                    if (pGetConditionField.numberRemainingBox <= 0) {
                        pGetConfigField.error = true;
                        pGetConfigField.errorField = tranferMessagesFormShortCode(msgItem?.messages ?? '', { 0: pBlockItem.block_name });
                        pCheckMessage = false;
                        return false;
                    }
                }
                break;
            case 'required_other':
                const configFieldText = pconfigBlockForm[pValidateKey]?.[pBlockItem.id]?.configFieldText;
                if (!configFieldText?.valueSync) {
                    configFieldText.error = true;
                    configFieldText.errorField = msgItem.messages;
                    pCheckMessage = false;
                    return false;
                }
                break;
            // case 'character_input':
            //     if (pGetConditionField && value) {
            //         pGetConfigField.errorField = msgItem?.messages || null;
            //         pCheckMessage = false;
            //         return false;
            //     }
            //     break;
            // case 'duplicate':
            //     if (pGetConditionField && pGetConditionField.valueSync) {
            //         pGetConfigField.errorField = msgItem?.messages || null;
            // pCheckMessage = false;
            //         return false;
            //     }
            //     break;
            case 'character_range':
                if (
                    pGetConditionField &&
                    value &&
                    value.length <= pBlockItem.max_characters &&
                    pGetConfigField.min.toString().length &&
                    pGetConfigField.max.toString() &&
                    (value.length < Number(pGetConfigField.min) || value.length > Number(pGetConfigField.max))
                ) {
                    const replacements = {
                        0: pGetConfigField.min,
                        1: pGetConfigField.max
                    };
                    pGetConfigField.error = true;
                    pGetConfigField.errorField = tranferMessagesFormShortCode(msgItem?.messages ?? '', replacements) || null;
                    pCheckMessage = false;
                    return false;
                }
                break;
            case 'email':
                pconfigBlockForm.modelInput[pBlockItem.id] = pconfigBlockForm.modelInput[pBlockItem.id].trim();
                pconfigBlockForm.modelConfirmInput[pBlockItem.id] = pconfigBlockForm.modelConfirmInput[pBlockItem.id].trim();
                if (value.trim() && !regexEmail(value.trim())) {
                    pGetConfigField.error = true;
                    pGetConfigField.errorField = msgItem.messages;
                    pCheckMessage = false;
                    return false;
                }
                break;
            case 'number':
                const regexMultiple = /^[0-9]+$/;
                if (pGetConditionField && value && !regexMultiple.test(value)) {
                    if (pBlockItem.block_type === ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE) {
                        pconfigBlockForm.validatePostcode_1[pBlockItem.id].configField.error = true;
                        pconfigBlockForm.validatePostcode_2[pBlockItem.id].configField.error = true;
                    }
                    pGetConfigField.error = true;
                    pGetConfigField.errorField = msgItem?.messages || null;
                    pCheckMessage = false;
                    return false;
                } else {
                    if (pBlockItem.block_type === ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE) {
                        pconfigBlockForm.validatePostcode_1[pBlockItem.id].configField.error = false;
                        pconfigBlockForm.validatePostcode_2[pBlockItem.id].configField.error = false;
                        if (
                            pconfigBlockForm.validatePostcodeCommon[pBlockItem.id].configField?.valueSync &&
                            pconfigBlockForm.validatePostcodeCommon[pBlockItem.id].configField?.valueSync.length < 7
                        ) {
                            pconfigBlockForm.validatePostcode_1[pBlockItem.id].configField.error = true;
                            pconfigBlockForm.validatePostcode_2[pBlockItem.id].configField.error = true;
                            pconfigBlockForm.validatePostcodeCommon[pBlockItem.id].configField.errorField = msgItem?.messages || null;
                            pCheckMessage = false;
                            return false;
                        }
                    }

                    if (pBlockItem.block_type === ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER) {
                        if (pconfigBlockForm.validatePhoneCommon[pBlockItem.id].configField?.valueSync) {
                            pconfigBlockForm.validateInputPhone_1[pBlockItem.id].configField.error = false;
                            pconfigBlockForm.validateInputPhone_2[pBlockItem.id].configField.error = false;
                            pconfigBlockForm.validateInputPhone_3[pBlockItem.id].configField.error = false;
                            if (!validateJapanesePhoneNumber(pconfigBlockForm.validatePhoneCommon[pBlockItem.id].configField?.valueSync)) {
                                pconfigBlockForm.validateInputPhone_1[pBlockItem.id].configField.error = true;
                                pconfigBlockForm.validateInputPhone_2[pBlockItem.id].configField.error = true;
                                pconfigBlockForm.validateInputPhone_3[pBlockItem.id].configField.error = true;
                                pconfigBlockForm.validatePhoneCommon[pBlockItem.id].configField.errorField = msgItem?.messages || null;
                                pCheckMessage = false;
                                return false;
                            }
                        } else {
                            if (!pconfigBlockForm.validatePhoneCommon[pBlockItem.id].configField.typesValidate.includes('required')) {
                                pconfigBlockForm.validateInputPhone_1[pBlockItem.id].configField.error = false;
                                pconfigBlockForm.validateInputPhone_2[pBlockItem.id].configField.error = false;
                                pconfigBlockForm.validateInputPhone_3[pBlockItem.id].configField.error = false;
                            }
                        }
                    }
                }

                break;
            case 'half-width_alphanumeric_characters':
                if (pGetConditionField && value && !regexHalfWidthAlphanumeric(pGetConditionField.valueSync)) {
                    pGetConfigField.errorField = msgItem?.messages || null;
                    pCheckMessage = false;
                    return false;
                }
                break;
            case 'full-width_characters':
                if (pGetConditionField && value && !regexFullWidthCharacters(value)) {
                    pGetConfigField.errorField = msgItem?.messages || null;
                    pCheckMessage = false;
                    return false;
                }
                break;
            case 'hiragana':
                if (pGetConditionField && value && !regexHiragana(value)) {
                    pGetConfigField.error = true;
                    pGetConfigField.errorField = msgItem?.messages || null;
                    pCheckMessage = false;
                    return false;
                }
                break;
            case 'katakana':
                if (pGetConditionField && value && !regexKatakana(value)) {
                    pGetConfigField.errorField = msgItem?.messages || null;
                    pCheckMessage = false;
                    return false;
                }
                break;
            case 'full-width_katakana':
                if (pGetConditionField && value.trim() && !regexFullWidthKatakana(value)) {
                    pGetConfigField.errorField = msgItem?.messages || null;
                    pCheckMessage = false;
                    return false;
                }
                break;
            case 'half-width_katakana':
                if (pGetConditionField && value.trim() && !regexHalfWidthKatakana(value)) {
                    pGetConfigField.errorField = msgItem?.messages || null;
                    pCheckMessage = false;
                    return false;
                }
                break;
            case 'age_condition':
                if (pGetConditionField && value !== undefined && value !== null && value !== '') {
                    const inputNum = Number(value);
                    const operatorVal =
                        typeof pBlockItem.block_input?.age_condition?.operator === 'object'
                            ? pBlockItem.block_input?.age_condition?.operator?.value
                            : pBlockItem.block_input?.age_condition?.operator;
                    const targetAge = Number(pBlockItem.block_input?.age_condition?.value);

                    if (!isNaN(inputNum) && operatorVal && !isNaN(targetAge)) {
                        let isValid = true;
                        switch (operatorVal) {
                            case '>':
                                isValid = inputNum > targetAge;
                                break;
                            case '<':
                                isValid = inputNum < targetAge;
                                break;
                            case '=':
                                isValid = inputNum === targetAge;
                                break;
                            case '>=':
                            case '≧':
                                isValid = inputNum >= targetAge;
                                break;
                            case '<=':
                            case '≦':
                                isValid = inputNum <= targetAge;
                                break;
                        }
                        if (!isValid) {
                            pGetConfigField.error = true;
                            pGetConfigField.errorField = msgItem?.messages || null;
                            pCheckMessage = false;
                            return false;
                        }
                    }
                }
                break;
            case 'format_numerical_value':
                if (pGetConditionField && value && !regexDynamicRange(value, '', '')) {
                    pGetConfigField.errorField = msgItem?.messages || null;
                    pCheckMessage = false;
                    return false;
                }
                break;
            case 'numerical_value':
                const subNumberValueSmallThan10 = 2147483648;
                const numberValueSmallThan10 = 2147483647;
                const getNumberSub = value.split('-')[1] ?? '';

                if (pBlockItem.block_input.is_bank_code && !!value && !validateJapaneseBankCode(value)) {
                    const replacements = {
                        0: '0001',
                        1: shiftDecimalLargeNumber(generateNinesString(Number(pGetConfigField.maxlength) - 1), 0)
                    };
                    pGetConfigField.error = true;
                    pGetConfigField.errorField = tranferMessagesFormShortCode(msgItem?.messages ?? '', replacements) || null;
                    pCheckMessage = false;
                    return false;
                }

                if (pBlockItem.block_input.is_store_number && !!value && !validateJapaneseStoreNumber(value)) {
                    const replacements = {
                        0: '001',
                        1: shiftDecimalLargeNumber(generateNinesString(Number(pGetConfigField.maxlength) - 1), 0)
                    };
                    pGetConfigField.error = true;
                    pGetConfigField.errorField = tranferMessagesFormShortCode(msgItem?.messages ?? '', replacements) || null;
                    pCheckMessage = false;
                    return false;
                }

                if (pBlockItem.block_input.is_account_number && !!value && !validateJapaneseAccountNumber(value)) {
                    const replacements = {
                        0: '0000001',
                        1: shiftDecimalLargeNumber(generateNinesString(Number(pGetConfigField.maxlength) - 1), 0)
                    };
                    pGetConfigField.error = true;
                    pGetConfigField.errorField = tranferMessagesFormShortCode(msgItem?.messages ?? '', replacements) || null;
                    pCheckMessage = false;
                    return false;
                }

                if (!pBlockItem.block_input.is_bank_code || !pBlockItem.block_input.is_store_number || !pBlockItem.block_input.is_account_number) {
                    const fromToRagecondition = !!pGetConditionField && !!value && (!!pGetConfigField.from_range || !!pGetConfigField.to_range);
                    const maxLengthCondition =
                        !!pGetConditionField &&
                        !!value &&
                        !!pGetConfigField.maxlength &&
                        !getNumberSub?.length &&
                        value?.length > Number(pGetConfigField.maxlength) - 1;

                    if (fromToRagecondition) {
                        pGetConfigField.from_range = pGetConfigField.from_range
                            ? Number(pGetConfigField.from_range)
                            : `-${shiftDecimalLargeNumber(generateNinesString(Number(pBlockItem.max_characters)), 0)}`;
                        pGetConfigField.to_range = pGetConfigField.to_range
                            ? Number(pGetConfigField.to_range)
                            : shiftDecimalLargeNumber(generateNinesString(Number(pBlockItem.max_characters)), 0);
                        if (!regexDynamicRange(value, Number(pGetConfigField.from_range), Number(pGetConfigField.to_range))) {
                            const replacements = {
                                0: pGetConfigField.from_range,
                                1: pGetConfigField.to_range
                            };
                            pGetConfigField.error = true;
                            pGetConfigField.errorField = tranferMessagesFormShortCode(msgItem?.messages ?? '', replacements) || null;
                            pCheckMessage = false;
                            return false;
                        }
                    }

                    if (
                        maxLengthCondition ||
                        (getNumberSub?.length && Number(pGetConfigField.maxlength) > 10 && Number(getNumberSub) < subNumberValueSmallThan10) ||
                        value > numberValueSmallThan10
                    ) {
                        const lengthTruth = Number(pGetConfigField.maxlength) - 1;
                        const replacements = {
                            0:
                                Number(pGetConfigField.maxlength) < 10
                                    ? `-${shiftDecimalLargeNumber(generateNinesString(Number(lengthTruth)), 0)}`
                                    : `-${subNumberValueSmallThan10}`,
                            1:
                                Number(pGetConfigField.maxlength) < 10
                                    ? shiftDecimalLargeNumber(generateNinesString(Number(lengthTruth)), 0)
                                    : numberValueSmallThan10
                        };
                        pGetConfigField.error = true;
                        pGetConfigField.errorField = tranferMessagesFormShortCode(msgItem?.messages ?? '', replacements) || null;
                        pCheckMessage = false;
                        return false;
                    }
                }
                break;
            case 'numeric_value_including_decimal_point':
                const getPriority = pBlockItem.block_input.number_after_decimal_point
                    ? pBlockItem.block_input.number_after_decimal_point
                    : pGetConfigField.decimal;
                const typeGetPriority = Number(getPriority);

                if (
                    pGetConditionField &&
                    value &&
                    !validateNumberWithMessage(value, pGetConfigField.integer, typeGetPriority, pGetConfigField.from_range, pGetConfigField.to_range)
                ) {
                    const replacements = {
                        0:
                            pBlockItem.block_input?.from_range && pBlockItem.block_input?.to_range
                                ? getIntegerLength(pBlockItem.block_input?.to_range)
                                : pGetConfigField.integer,
                        1: getPriority.toString(),
                        2: pGetConfigField.from_range
                            ? pGetConfigField.from_range
                            : `-${shiftDecimalLargeNumber(generateNinesString(Number(pBlockItem.block_input.number_of_digits)), typeGetPriority)}`,
                        3: pGetConfigField.to_range
                            ? pGetConfigField.to_range
                            : shiftDecimalLargeNumber(generateNinesString(Number(pBlockItem.block_input.number_of_digits)), typeGetPriority)
                    };
                    pGetConfigField.error = true;
                    pGetConfigField.errorField = tranferMessagesFormShortCode(msgItem?.messages ?? '', replacements) || null;
                    pCheckMessage = false;
                    return false;
                }
                break;
            case 'maxlength_textarea':
                if (pBlockItem.block_input.maximum_number != '' && value && value.length > Number(pBlockItem.block_input.maximum_number)) {
                    let returnDefault = pBlockItem.max_characters;
                    if (pBlockItem.block_input.minimum_number) {
                        returnDefault = pBlockItem.block_input.minimum_number;
                    } else {
                        returnDefault = pBlockItem.block_input.maximum_number;
                    }
                    const replacements = {
                        0: returnDefault,
                        1: pBlockItem.block_input.maximum_number ? pBlockItem.block_input.maximum_number : ''
                    };
                    pGetConfigField.error = true;
                    pGetConfigField.errorField = tranferMessagesFormShortCode(msgItem.messages ?? '', replacements);
                    pCheckMessage = false;
                    return false;
                }
                if (
                    pBlockItem.block_input.minimum_number &&
                    pBlockItem.block_input.maximum_number == '' &&
                    value &&
                    value.length < Number(pBlockItem.block_input.minimum_number)
                ) {
                    const replacements = {
                        0: pBlockItem.block_input.minimum_number,
                        1: pBlockItem.max_characters
                    };
                    pGetConfigField.error = true;
                    pGetConfigField.errorField = tranferMessagesFormShortCode(msgItem.messages ?? '', replacements);
                    pCheckMessage = false;
                    return false;
                }
                if (pBlockItem.block_type === ALL_BLOCK_TYPE.BLOCK_TEXTAREA) {
                    if (value && value.length > Number(pBlockItem.max_characters)) {
                        const replacements = {
                            0: pBlockItem.max_characters
                        };
                        pGetConfigField.error = true;
                        pGetConfigField.errorField = tranferMessagesFormShortCode(msgItem.messages ?? '', replacements);
                        pCheckMessage = false;
                        return false;
                    }
                }
                break;

            case 'keyword_pattern':
                const confirmedBlockInput =
                    pBlockItem.block_type === ALL_BLOCK_TYPE.BLOCK_INPUT && pBlockItem.block_input.confirm_input_twice == OPTION_YES_NO[0]?.id;
                if (!confirmedBlockInput) {
                    let objectCheck = {};
                    const matchingConditionKeywordBox = pBlockItem.block_keyword_box.matching_condition;
                    if (
                        matchingConditionKeywordBox.includes(LIST_MATCHING_CONDITION[0]?.id) ||
                        matchingConditionKeywordBox.includes(LIST_MATCHING_CONDITION[1]?.id) ||
                        matchingConditionKeywordBox.includes(LIST_MATCHING_CONDITION[2]?.id)
                    ) {
                        objectCheck = {
                            caseSensitive: matchingConditionKeywordBox.includes(LIST_MATCHING_CONDITION[0]?.id),
                            fullHalfWidth: matchingConditionKeywordBox.includes(LIST_MATCHING_CONDITION[1]?.id),
                            kanaSensitive: matchingConditionKeywordBox.includes(LIST_MATCHING_CONDITION[2]?.id)
                        };
                    }

                    if (pGetConditionField && value && !checkKeywordPattern(value, pBlockItem.block_keyword_box.keyword_characters, objectCheck)) {
                        pGetConfigField.error = true;
                        pGetConfigField.errorField = msgItem?.messages || null;
                        pCheckMessage = false;
                        return false;
                    }
                }

                if (
                    confirmedBlockInput &&
                    (pconfigBlockForm.modelInput[pBlockItem.id].toString() || pconfigBlockForm.modelConfirmInput[pBlockItem.id].toString())
                ) {
                    if (pconfigBlockForm.modelInput[pBlockItem.id].toString() !== pconfigBlockForm.modelConfirmInput[pBlockItem.id].toString()) {
                        pGetConfigField.error = true;
                        pGetConfigField.errorField = msgItem?.messages || null;
                        pCheckMessage = false;
                        return false;
                    } else {
                        pGetConfigField.error = false;
                    }
                }
                break;
            case 'date':
                if (pGetConditionField && value && !getDateFromFullDate(value)) {
                    typeSelectDateValueError(configSelectYear, configSelectMonth, configSelectDay, pGetConfigField.error);
                    pGetConfigField.errorField = msgItem?.messages || null;
                    pCheckMessage = false;
                    return false;
                } else {
                    typeSelectDateValueError(configSelectYear, configSelectMonth, configSelectDay, pGetConfigField.error);
                }
                break;
            case 'date_year_range':
                if (
                    pGetConditionField &&
                    value &&
                    getDateFromFullDate(value) &&
                    pGetConditionField.minYear &&
                    !isDateRangeYear(value, pGetConditionField.minYear, pGetConditionField.maxYear)
                ) {
                    const replacements = {
                        0: pGetConfigField.minYear,
                        1: pGetConfigField.maxYear
                    };
                    pGetConfigField.errorField = tranferMessagesFormShortCode(msgItem?.messages ?? '', replacements) || null;
                    pCheckMessage = false;
                    return false;
                } else {
                    if (value && getDateFromFullDate(value)) {
                        typeSelectDateValueError(configSelectYear, configSelectMonth, configSelectDay, pGetConfigField.error);
                    }
                }
                break;
            case 'checked_quantity_error':
                const numberLimit = Number(pBlockItem.block_checkbox.number_limit_check);
                const checkLengthLimit = value?.length < numberLimit;
                if (pGetConditionField && value?.length && checkLengthLimit) {
                    const replacements = {
                        0: numberLimit
                    };
                    pGetConfigField.error = true;
                    pGetConfigField.errorField = tranferMessagesFormShortCode(msgItem?.messages ?? '', replacements) || null;
                    pCheckMessage = false;
                    return false;
                }
                break;
        }
    }

    return pCheckMessage;
};

const generateNinesString = (n) => {
    if (typeof n !== 'number' || n <= 0) return '';
    return '9'.repeat(n);
};

const shiftDecimalLargeNumber = (numStr, decimalDigits = 2) => {
    if (typeof numStr !== 'string' || typeof decimalDigits !== 'number') return '';
    const len = numStr.length;
    if (decimalDigits === 0) return numStr;
    if (len <= decimalDigits) {
        const zeros = '0'.repeat(decimalDigits - len);
        return `0.${zeros}${numStr}`;
    }
    const intPart = numStr.slice(0, len - decimalDigits);
    const decimalPart = numStr.slice(len - decimalDigits);
    return `${intPart}.${decimalPart}`;
};

const validateNumberWithMessage = (input, maxIntegerDigits = 10, maxDecimalDigits = 3, fromRange = 0, toRange = 0) => {
    // Tạo regex kiểm tra format tổng quát
    const regex =
        maxDecimalDigits === 0
            ? new RegExp(`^-?\\d{1,${maxIntegerDigits}}$`)
            : new RegExp(`^-?\\d{1,${maxIntegerDigits}}(\\.\\d{1,${maxDecimalDigits}})?$`);

    if (!regex.test(input) || (maxDecimalDigits === 0 && input.includes('.'))) {
        return false;
    }
    // Kiểm tra chi tiết phần nguyên/phần thập phân
    const [integerPart, decimalPart = ''] = input.replace('-', '').split('.');
    if (integerPart.length > maxIntegerDigits || decimalPart.length > maxDecimalDigits) {
        return false;
    }
    // Kiểm tra giá trị nằm trong range
    const value = Number(input);
    if (fromRange && toRange) {
        if (value < fromRange || value > toRange) {
            return false;
        }
    }
    if (fromRange && value < fromRange) return false;
    if (toRange && value > toRange) return false;
    return true;
};

const getIntegerLength = (value) => {
    const str = value.toString();
    const [integerPart] = str.split('.'); // tách trước dấu chấm
    return integerPart.replace('-', '').length; // bỏ dấu âm nếu có
};

const typeSelectDateValueError = (configSelectYear, configSelectMonth, configSelectDay, isError) => {
    configSelectYear.error = isError;
    configSelectMonth.error = isError;
    configSelectDay.error = isError;
};

const tranferMessagesFormShortCode = (dataShortCode, replacements) => {
    let result = dataShortCode;
    if (!result) return '';
    return result.replace(/{(.*?)}/g, (match, p1) => {
        return replacements[p1] || '';
    });
};

const incrementIndex = (idxComponent) => {
    idxComponent++;
    return (idxComponent = idxComponent >= 100 ? 0 : idxComponent);
};

const generateYearList = (start = 1872, end = 2100, type = 3) => {
    const result = [];
    const eras = [
        { name: '明治', start: 1868, end: 1912 },
        { name: '大正', start: 1912, end: 1926 },
        { name: '昭和', start: 1926, end: 1989 },
        { name: '平成', start: 1989, end: 2019 },
        { name: '令和', start: 2019, end: 2101 }
    ];
    switch (type) {
        case 1:
            for (let y = start; y <= end; y++) {
                const label = `${y}年`;
                result.push({ unique_key: label, label, value: y });
            }
            break;
        case 2:
            for (let year = start; year <= end; year++) {
                const currentEra = eras.find((e) => year >= e.start && year <= e.end);
                if (!currentEra) continue;
                const eraYear = year - currentEra.start + 1;
                let label = '';
                // Xử lý năm chuyển niên hiệu
                const nextEra = eras.find((e) => e.start === year);
                if (nextEra && year !== start) {
                    const prevEra = eras.find((e) => e.end === year);
                    const prevEraYear = year - prevEra.start + 1;
                    label = `${prevEra.name}${prevEraYear}年 / ${nextEra.name}元年`;
                } else {
                    label = `${currentEra.name}${eraYear === 1 ? '元' : eraYear}年`;
                }
                result.push({ unique_key: label, label, value: year });
            }
            break;
        case 3:
            for (let i = 0; i < eras.length; i++) {
                const era = eras[i];
                const eraEnd = Math.min(era.end - 1, end); // loại trừ năm chuyển giao khỏi era cũ
                for (let y = Math.max(era.start, start); y <= eraEnd; y++) {
                    const eraYear = y - era.start + 1;
                    const label = eraYear === 1 ? `${era.name}元年` : `${era.name}${eraYear}年`;
                    result.push({ unique_key: label, label: `${y}年( ${label} )`, value: y });
                }
            }
            break;
    }

    return result;
};

const MONTH_OPTIONS = Array.from({ length: 12 }, (_, i) => {
    const month = i + 1;
    return {
        unique_key: month < 10 ? `0${month}` : month,
        label: `${month}${i18n.t('text.month')}`,
        value: month < 10 ? `0${month}` : month
    };
});
const DAY_OPTIONS = Array.from({ length: 31 }, (_, i) => {
    const day = i + 1;
    return {
        unique_key: day < 10 ? `0${day}` : day,
        label: `${day}${i18n.t('text.day')}`,
        value: day < 10 ? `0${day}` : day
    };
});

const isShowDateFormType = (formatYearType, formatMonthDayType) => {
    if (formatYearType == 1 && formatMonthDayType == 1) return 'inputDate';
    if (formatYearType == 2 && formatMonthDayType == 2) return 'selectDate';
};

const onHandleMapCssForm = (settingDesigns) => {
    let rootForm = document.documentElement;
    let { character_settings, background_settings, background_image, table_settings } = settingDesigns;
    const isLayoutHorizontal = table_settings.question_layout === 'horizontal';
    rootForm.style.setProperty('--form-font-family', character_settings?.qa_typography?.font?.value ?? 'inherit');
    rootForm.style.setProperty(
        '--form-font-size',
        character_settings?.qa_typography?.font_size
            ? `${character_settings?.qa_typography?.font_size}${character_settings?.qa_typography?.unit.value}`
            : '16px'
    );
    rootForm.style.setProperty('--form-color', character_settings?.qa_typography?.color ?? 'inherit');
    rootForm.style.setProperty('--form-background-color', background_settings?.background_color ?? 'inherit');
    rootForm.style.setProperty('--form-background-image', background_image?.path ? `url(${background_image?.path})` : 'inherit');
    rootForm.style.setProperty('--form-background-size', background_settings?.is_full_width_bg_image ? '100% auto' : 'auto');
    rootForm.style.setProperty('--form-background-repeat', onHandleGetValueRepeat(background_settings?.repeat) ?? 'no-repeat');
    rootForm.style.setProperty(
        '--form-background-position',
        `${background_settings?.horizontal_direction?.value === 'none' ? 'left' : background_settings?.horizontal_direction?.value} ${background_settings?.vertical_direction?.value === 'none' ? 'top' : background_settings?.vertical_direction?.value}` ??
            'left top'
    );
    rootForm.style.setProperty('--form-background-attachment', 'scroll');
    // error
    rootForm.style.setProperty('--form-error-font-family', character_settings?.error_typography?.font?.value ?? 'inherit');
    rootForm.style.setProperty(
        '--form-error-font-size',
        character_settings?.error_typography?.font_size
            ? `${character_settings?.error_typography?.font_size}${character_settings?.error_typography?.unit.value}`
            : '80%'
    );
    rootForm.style.setProperty('--form-error-color', character_settings?.error_typography?.color ?? '#ff3d60');
    rootForm.style.setProperty('--form-error-list-style-type', character_settings?.error_typography?.heading_style?.value ?? 'inherit');
    // placeholder
    rootForm.style.setProperty('--form-placerholder-color', character_settings?.color_input_placeholder ?? 'inherit');
    // container__form
    rootForm.style.setProperty(
        '--container--form-width',
        table_settings?.width?.table_width ? `${table_settings?.width?.table_width}${table_settings?.width?.unit.value}` : '100%'
    );
    // question_layout
    rootForm.style.setProperty(
        '--form-width-fm-question',
        table_settings?.width?.question_width && isLayoutHorizontal
            ? `${table_settings?.width?.question_width}${table_settings?.width?.unit.value}`
            : 'auto'
    );
    rootForm.style.setProperty(
        '--form-width-fm-answer',
        table_settings?.width?.answer_width && isLayoutHorizontal
            ? `${table_settings?.width?.answer_width}${table_settings?.width?.unit.value}`
            : 'auto'
    );
    rootForm.style.setProperty(
        '--form-padding-top',
        table_settings?.display_position_in_browser?.top?.value
            ? `${table_settings?.display_position_in_browser?.top?.value}${table_settings?.display_position_in_browser?.top?.unit?.value}`
            : '0'
    );
    rootForm.style.setProperty(
        '--form-padding-bottom',
        table_settings?.display_position_in_browser?.bottom?.value
            ? `${table_settings?.display_position_in_browser?.bottom?.value}${table_settings?.display_position_in_browser?.bottom?.unit?.value}`
            : '0'
    );
    rootForm.style.setProperty(
        '--form-padding-left',
        table_settings?.display_position_in_browser?.left?.value
            ? `${table_settings?.display_position_in_browser?.left?.value}${table_settings?.display_position_in_browser?.left?.unit?.value}`
            : '0'
    );
    rootForm.style.setProperty(
        '--form-padding-right',
        table_settings?.display_position_in_browser?.right?.value
            ? `${table_settings?.display_position_in_browser?.right?.value}${table_settings?.display_position_in_browser?.right?.unit?.value}`
            : '0'
    );
    rootForm.style.setProperty('--table--margin-inset', onHandleGetValueMargin(table_settings, 'inset') ?? 'auto');
    rootForm.style.setProperty('--table--form-border-type', table_settings?.border_setting?.type?.value ?? 'none');
    rootForm.style.setProperty('--table--form-border-color', table_settings?.border_setting?.color ?? 'none');
    rootForm.style.setProperty('--form--border-type', table_settings?.border_setting?.type?.value ?? 'none');
    rootForm.style.setProperty('--form--border-color', table_settings?.border_setting?.color ?? 'none');
    rootForm.style.setProperty(
        '--table--form-border-width',
        table_settings?.line_thickness?.value ? `${table_settings?.line_thickness?.value}${table_settings?.line_thickness?.unit.value}` : 'inherit'
    );
    rootForm.style.setProperty('--table--form-border-collapse', table_settings?.line_display ?? 'inherit');
    rootForm.style.setProperty(
        '--form--border-width',
        table_settings?.line_thickness?.value ? `${table_settings?.line_thickness?.value}${table_settings?.line_thickness?.unit.value}` : 'inherit'
    );
    rootForm.style.setProperty(
        '--form-padding-inline',
        table_settings?.cell_setting?.margin?.value
            ? `${table_settings?.cell_setting?.margin?.value}${table_settings?.cell_setting?.margin?.unit?.value}`
            : '30px'
    );
    rootForm.style.setProperty(
        '--form-padding-block',
        table_settings?.cell_setting.margin?.value
            ? `${table_settings?.cell_setting.margin?.value}${table_settings?.cell_setting.margin?.unit?.value}`
            : '30px'
    );
    rootForm.style.setProperty('--form-background-color-fm-question', table_settings?.cell_background_color?.question_background_color ?? 'inherit');
    rootForm.style.setProperty('--form-background-color-fm-answer', table_settings?.cell_background_color?.answer_background_color ?? 'inherit');
    rootForm.style.setProperty(
        '--form-text-align-fm-question',
        onHandleGetValueTextAlign(table_settings.question_text_alignment.horizontal) ?? 'inherit'
    );
    rootForm.style.setProperty(
        '--form-vertical-align-fm-question',
        onHandleGetValueVerticalAlign(table_settings.question_text_alignment.vertical) ?? 'inherit'
    );
    rootForm.style.setProperty(
        '--form-text-align-fm-answer',
        onHandleGetValueTextAlign(table_settings.answer_text_alignment.horizontal) ?? 'inherit'
    );
    rootForm.style.setProperty(
        '--form-vertical-align-fm-answer',
        onHandleGetValueVerticalAlign(table_settings.answer_text_alignment.vertical) ?? 'inherit'
    );
};
const onHandleSetStyleLabel = (labelInfor, labelType = 'require') => {
    const colorDefault = labelType === 'require' ? '#ff3d60' : '#333333';
    return `
        display: ${labelInfor?.display === 0 ? 'none' : 'inline-block'};
        font-family: ${labelInfor?.font.value};
        font-size: ${labelInfor?.font_size}${labelInfor?.unit.value};
        color: ${labelInfor?.color ?? colorDefault};
    `;
};

const onHandleGetValueMargin = (settingMargin, typeMargin) => {
    const valueLayoutMargin = settingMargin.layout_alignment_setting;
    switch (typeMargin) {
        case 'inset':
            if (['align_left'].includes(valueLayoutMargin)) {
                return '0 auto 0 0';
            } else if (['align_center'].includes(valueLayoutMargin)) {
                return '0 auto';
            } else if (['align_right'].includes(valueLayoutMargin)) {
                return '0 0 0 auto';
            } else {
                return 'auto';
            }
    }
};

const onHandleGetValueTextAlign = (valueHorizontal) => {
    switch (valueHorizontal) {
        case 'align_left':
            return 'left';
        case 'align_center':
            return 'center';
        case 'align_right':
            return 'right';
    }
};

const onHandleGetValueVerticalAlign = (valueVertical) => {
    switch (valueVertical) {
        case 'align_top':
            return 'top';
        case 'align_center':
            return 'middle';
        case 'align_bottom':
            return 'bottom';
    }
};

const onHandleGetValueRepeat = (valueRepeat) => {
    if (valueRepeat?.length <= 0) return 'no-repeat';

    if (valueRepeat.includes('horizontal') && valueRepeat.includes('vertical')) {
        return 'repeat';
    }
    if (valueRepeat.includes('horizontal')) {
        return 'repeat-x';
    } else if (valueRepeat.includes('vertical')) {
        return 'repeat-y';
    }
};

const validateJapaneseBankCode = (code) => {
    const regex = /^\d{4}$/;
    if (!regex.test(code)) {
        return false;
    }
    return code !== '0000';
};
const validateJapaneseStoreNumber = (store) => {
    const regex = /^\d{3}$/;
    if (!regex.test(store)) {
        return false;
    }
    return store !== '000';
};
const validateJapaneseAccountNumber = (account) => {
    const regex = /^\d{7}$/;
    if (!regex.test(account)) {
        return false;
    }
    return account !== '0000000';
};

const validateJapanesePhoneNumber = (phoneNumber) => {
    if (!phoneNumber || typeof phoneNumber !== 'string') {
        return false;
    }
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    const length = cleanedNumber.length;
    if (length !== 10 && length !== 11) {
        return false;
    }
    if (cleanedNumber.charAt(0) !== '0') {
        return false;
    }
    return true;
};

function returnActualValuePhoneNumber(modelInput, id) {
    const phone1 = modelInput.modelInputPhone_1?.[id];
    const phone2 = modelInput.modelInputPhone_2?.[id];
    const phone3 = modelInput.modelInputPhone_3?.[id];
    if (phone1 || phone2 || phone3) {
        return `${phone1 ?? ''}-${phone2 ?? ''}-${phone3 ?? ''}`;
    } else if (phone1 && phone2) {
        return `${phone1 ?? ''}-${phone2 ?? ''}`;
    } else if (phone1) {
        return `${phone1 ?? ''}-`;
    } else {
        return '';
    }
}
function isValidDate(dateStr) {
    if (!/^\d{4}-\d{1,2}-\d{1,2}$/.test(dateStr)) return false;
    const date = new Date(dateStr);
    return !isNaN(date);
}
function formatDate(dateStr) {
    const [year, month, day] = dateStr.split('-').map(Number);
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}
function returnActualValueDate(modelInput, id) {
    const dateObj = modelInput.modelDateForm?.[id];
    if (dateObj.text) {
        if (isValidDate(dateObj.text)) {
            return formatDate(dateObj.text);
        } else return '';
    } else {
        const year = dateObj.select.year.value || '';
        const month = dateObj.select.month.value || '';
        const day = dateObj.select.day.value || '';
        if (year && month && day) {
            return `${year}-${month}-${day}`;
        } else return '';
    }
}
function getFieldValue(modelInput, block) {
    const id = block.id;
    if (block.block_type === ALL_BLOCK_TYPE.BLOCK_FULL_NAME) {
        if (block.block_type_name === 'first_name') {
            return modelInput.modelFirstName?.[id] || '';
        }
        if (block.block_type_name === 'last_name') {
            return modelInput.modelLastName?.[id] || '';
        }
    }
    // postal code
    if (block.block_type === ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE) {
        return modelInput.modelPostcode_1?.[id] || modelInput.modelPostcode_2?.[id]
            ? `${modelInput.modelPostcode_1?.[id]}-${modelInput.modelPostcode_2?.[id]}`
            : '';
    }

    // phone number
    if (block.block_type === ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER) {
        return returnActualValuePhoneNumber(modelInput, id);
    }

    // seatbox
    if (block.block_type === ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY) {
        return modelInput.modelRemainingBox?.[id];
    }

    // input
    if (modelInput.modelInput?.[id] !== undefined) {
        return modelInput.modelInput[id];
    }

    //textarea
    if (modelInput.modelTextarea?.[id] !== undefined) {
        return modelInput.modelTextarea[id];
    }
    //uploadFile
    if (modelInput.modelUploadFile?.[id] !== undefined) {
        return modelInput.modelUploadFile[id];
    }

    // confirm input
    if (modelInput.modelConfirmInput?.[id] !== undefined) {
        return modelInput.modelConfirmInput[id];
    }

    // select / radio / checkbox
    if (modelInput.modelSelect?.[id]?.unique_key !== undefined) {
        return modelInput.modelSelect[id].unique_key;
    }
    if (modelInput.modelRadio?.[id]) {
        return modelInput.modelRadio[id].radio;
    }
    if (modelInput.modelCheckbox?.[id]) {
        return modelInput.modelCheckbox[id].checked;
    }

    // province
    if (modelInput.modelProvince?.[id]?.unique_key !== undefined) {
        return modelInput.modelProvince[id].unique_key;
    }

    // date
    if (modelInput.modelDateForm?.[id]) {
        return returnActualValueDate(modelInput, id);
    }

    // keyword box
    if (modelInput.modelKeywordBox?.[id]) {
        return modelInput.modelKeywordBox[id];
    }

    return '';
}
function checkCondition(actualValue, expectedValue, typeCondition) {
    if (actualValue == null) actualValue = '';
    if (expectedValue == null) expectedValue = '';

    // Chuẩn hóa expectedValue thành mảng string
    let expectedList = [];
    if (Array.isArray(expectedValue)) {
        expectedList = expectedValue.map((v) => (typeof v === 'object' ? v.unique_key : v));
    } else {
        expectedList = [expectedValue];
    }

    switch (typeCondition) {
        case 'equal':
            return actualValue === expectedList[0];

        case 'start_with':
            return typeof actualValue === 'string' && actualValue.startsWith(expectedList[0]);

        case 'end_with':
            return typeof actualValue === 'string' && actualValue.endsWith(expectedList[0]);

        case 'include':
            if (typeof actualValue === 'string') {
                return actualValue.includes(expectedList[0]);
            }
            if (Array.isArray(actualValue)) {
                return actualValue.some((v) => expectedList.includes(v));
            }
            return false;

        case 'no_answer':
            return actualValue == null || actualValue === '' || (Array.isArray(actualValue) && actualValue.length === 0);

        case 'has_answer':
            return !(actualValue == null || actualValue === '' || (Array.isArray(actualValue) && actualValue.length === 0));

        case 'select_one':
            if (Array.isArray(actualValue)) {
                return expectedList.some((v) => actualValue.includes(v));
            }
            if (typeof actualValue === 'string') {
                return expectedList.includes(actualValue);
            }
            return false;

        case 'select_all':
            if (Array.isArray(actualValue)) {
                return expectedList.every((v) => actualValue.includes(v));
            }
            if (typeof actualValue === 'string') {
                return expectedList.length === 1 && actualValue === expectedList[0];
            }
            return false;

        case 'gt_equal':
            if (!isNaN(Date.parse(actualValue)) && !isNaN(Date.parse(expectedList[0]))) {
                return new Date(actualValue) >= new Date(expectedList[0]);
            }
            return Number(actualValue) >= Number(expectedList[0]);

        case 'lt_equal':
            if (!isNaN(Date.parse(actualValue)) && !isNaN(Date.parse(expectedList[0]))) {
                return new Date(actualValue) <= new Date(expectedList[0]);
            }
            return Number(actualValue) <= Number(expectedList[0]);

        default:
            return false;
    }
}

function evaluateRule(rule, modelInput) {
    // Nếu không có rule hoặc conditions rỗng => coi như hợp lệ (field bình thường)
    if (!rule || !rule.conditions?.length) return true;

    const results = rule.conditions.map((cond) => {
        const actual = getFieldValue(modelInput, cond.block);
        const expected = cond.value?.value_input || cond.value?.select_value_block;
        return checkCondition(actual, expected, cond.condition_type);
    });

    return rule.type === 'AND' ? results.every(Boolean) : results.some(Boolean);
}

function evaluateAllRules(rules, modelInput) {
    const res = {};
    for (const key in rules) {
        const ok = evaluateRule(rules[key], modelInput);

        if (ok) {
            // Điều kiện đúng => field bình thường
            res[key] = { visible: true, disabled: false };
        } else {
            // Điều kiện sai => áp dụng status
            if (rules[key].status === 1) {
                res[key] = { visible: true, disabled: true };
            } else if (rules[key].status === 2) {
                res[key] = { visible: false, disabled: false };
            } else {
                res[key] = { visible: true, disabled: false }; // fallback
            }
        }
    }
    return res;
}

export {
    configBlockForm,
    handleFilterBlock,
    matchingMessageBlocks,
    incrementIndex,
    generateYearList,
    isShowDateFormType,
    onHandleMapCssForm,
    onHandleSetStyleLabel,
    onHandleGetValueTextAlign,
    evaluateRule,
    evaluateAllRules,
    MONTH_OPTIONS,
    DAY_OPTIONS,
    VALUE_ETC,
    VALUE_NAC,
    VALUE_NS
};
